import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import AboutHero from './components/AboutHero';
import OurStory from './components/OurStory';
import TrustStatistics from './components/TrustStatistics';
import ThreeTierExplainer from './components/ThreeTierExplainer';
import OurValues from './components/OurValues';
import AboutCTA from './components/AboutCTA';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <Navbar />
      <AboutHero />
      <OurStory />
      <TrustStatistics />
      <ThreeTierExplainer />
      <OurValues />
      <AboutCTA />
      <Footer />
    </div>
  );
}